export const hubspotPageMap = {
  '': 'Home',
  'commercial-kitchens': 'Kitchen',
  'restaurant-technology': 'Technology',
  partners: 'Partner',
  blog: 'Blog',
};
